import React from "react";
import { useRouter } from "next/router";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import { getFeatureFlagRouteConfig } from "@/config/releaseFlags";
import { useFeatureFlags } from "./feature-flags-provider";

export default function FeatureFlagsRouteGate({
  children,
}: {
  children: React.ReactNode;
}) {
  const router = useRouter();
  const { initialized, isEnabled } = useFeatureFlags();
  const featureFlagRoute = getFeatureFlagRouteConfig(router.pathname);
  const featureFlagKey = featureFlagRoute?.flagKey;
  const redirectTo = featureFlagRoute?.redirectTo ?? "/dashboard";
  const isEnabledFallback =
    featureFlagRoute?.fallbackEnabledWhenMissing ?? false;

  React.useEffect(() => {
    if (!featureFlagKey || !initialized) {
      return;
    }

    if (!isEnabled(featureFlagKey, isEnabledFallback)) {
      void router.replace(redirectTo);
    }
  }, [
    featureFlagKey,
    initialized,
    isEnabled,
    isEnabledFallback,
    redirectTo,
    router,
  ]);

  if (featureFlagKey && !initialized) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (
    featureFlagKey &&
    initialized &&
    !isEnabled(featureFlagKey, isEnabledFallback)
  ) {
    return null;
  }

  return <>{children}</>;
}
